import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M3.25 17C3.25 17.9665 4.0335 18.75 5 18.75H9.99998V17.25H5C4.86193 17.25 4.75 17.1381 4.75 17V14.6465C5.90425 14.32 6.75 13.2588 6.75 12V6.75H13.25V9.9999H14.75V6.75H15C15.9301 6.75 16.7523 6.28828 17.25 5.58154V9.9999H18.75V4.5C18.75 3.50588 18.1053 2.66236 17.2112 2.36471C16.7102 1.6884 15.9063 1.25 15 1.25H5C4.09371 1.25 3.28982 1.6884 2.78883 2.36471C1.89471 2.66236 1.25 3.50588 1.25 4.5V12C1.25 13.2588 2.09575 14.32 3.25 14.6465V17ZM2.75 5.58154C3.24768 6.28828 4.06992 6.75 5 6.75H5.25V12C5.25 12.6904 4.69036 13.25 4 13.25C3.30964 13.25 2.75 12.6904 2.75 12V5.58154ZM5 5.25C4.30964 5.25 3.75 4.69036 3.75 4C3.75 3.30964 4.30964 2.75 5 2.75H15C15.6904 2.75 16.25 3.30964 16.25 4C16.25 4.69036 15.6904 5.25 15 5.25H5Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M13.5765 18L10 14.3909L10.837 13.4873L13.3757 15.2488L17.9459 11L19 11.8814L13.5765 18Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const OnStageIcon = __component__.exports;
export {
  OnStageIcon as default
};
